import React from 'react';
import Table from '../../table/Table';
import GetState from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import { generateId, shortHandDate } from '../../utility/functions';
import Button from '../../forms/Button';
import LinkTo from '../../forms/LinkTo';
import Form from '../../forms/Form';
import HamQuest from '../../api/HamQuestGiver';
import ManageOrder from './ManageOrder';
import Input from '../../forms/Input';
import ModalFactory from '../../Modal';
import { userRoles } from '../../RoleProtected';
import { useGlobalState } from '../../stateProvider/StateProvider';

const Orders = ({ ...props }) => {

        const {
            state: {active_user},
        } = useGlobalState();

    const isAdmin = active_user.roles.includes(userRoles.admin);
    const [orders, refreshOrders] = GetState(QuestRoute.fulfillment.orders, {
        callback: e => {
            e.productsList = e.products.map(f => f.name).join(',')
        }
    });

    const completeOrder = (modalId, order) => {
        if (order.products.find(e => e.appProductType === 'GiftCard')) {
            const id = generateId();
            ModalFactory.show({
                id,
                title: 'Activate and Complete Order',
                body: (
                    <Form
                        inputs={{
                            cardNumber: ''
                        }}
                        onSubmit={e => (
                            HamQuest.put(QuestRoute.fulfillment.editOrder(order.orderId), {
                                orderId: order.orderId,
                                ...e
                            })
                                .then(() => {
                                    refreshOrders();
                                    ModalFactory.close(modalId, id);
                                })
                        )}
                        text='Activate and Complete'
                    >
                        <Input
                            label='Card Number'
                            name='cardNumber'
                            type='text'
                            required
                            sanitize={v => v.replace(/\D/g, '').slice(0, 16)}
                            validate={[
                                {
                                    regex: /^\d{16}$/,
                                    message: 'Card number must be 16 digits.'
                                }
                            ]}
                        />

                    </Form>
                )
            })
        } else {
            HamQuest.put(QuestRoute.fulfillment.editOrder(order.orderId), {
                orderId: order.orderId
            })
                .then(() => {
                    refreshOrders();
                    ModalFactory.close(modalId);
                })
                .catch(ModalFactory.catch)
        }
    }

    const adminCompleteOrder = (order) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Complete Order',
            body: (
                <Form
                    inputs={{}}
                    onSubmit={() => (
                        HamQuest.put(QuestRoute.fulfillment.editOrder(order.orderId), {
                            orderId: order.orderId
                        })
                            .then(() => {
                                refreshOrders();
                                ModalFactory.close(id);
                            })
                            .catch(ModalFactory.catch)
                    )}
                    text='Complete Order'
                >
                    <p>Are you sure you want to complete order #{order.orderId}?</p>
                </Form>
            )
        })
    }

    const manage = (order) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Manage Order`,
            // buttons: [<Button onClick={() => completeOrder(order)}>Complete Order</Button>, <Button>Print Order</Button>],
            buttons: [<Button onClick={() => completeOrder(id, order)}>Complete Order</Button>],
            body: <ManageOrder refresh={refreshOrders} {...order} />
        })
    }

    return (
        <Table
            config={{
                // label: 'Orders',
                colSpacing: isAdmin ? [6, 7, 12, 25, 15, 9, 10, 10] : [10, 10, 15, 30, 15, 10, 10],
                data: orders?.filter(e => !e.completed),
                headers: [
                    {
                        label: 'Order',
                        propKey: 'orderId',
                    }, {
                        label: 'Invoice',
                        propKey: 'invoiceId',
                    }, {
                        label: 'Customer',
                        propKey: 'customerName',
                    }, {
                        label: 'Address',
                        propKey: 'address',
                    }, {
                        label: 'Products',
                        propKey: 'productsList',
                    }, {
                        label: 'Ordered',
                        propKey: 'orderDate',
                        type: 'date'
                    }, {
                        label: 'Manage Order',
                    },
                    ...(isAdmin ? [{ label: 'Complete Order' }] : []),
                ],
                renderFormat: (e) => (
                    <tr key={generateId()}>
                        <td>{e.orderId}</td>
                        <td>
                            <LinkTo target='_blank' to={'/reporting/Sales/Invoice/' + e.invoiceId}>{e.invoiceId}</LinkTo>
                        </td>
                        <td>{e.customerName}</td>
                        <td>{e.address}</td>
                        <td>{e.products.map(f => `${f.name} (x${f.quantity})`)}</td>
                        <td>{shortHandDate(e.orderDate)}</td>
                        <td>
                            <Button onClick={() => manage(e)}>Manage</Button>
                        </td>
                        {isAdmin && (
                            <td>
                                <Button onClick={() => adminCompleteOrder(e)}>Complete</Button>
                            </td>
                        )}
                    </tr>
                )
            }}
        />
    );
}

export default Orders;
